import { CommonModule } from '@angular/common';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { KnBrOrderHistorySearchComponent } from './kn-br-order-history-search.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        NgbModule,
        FormErrorsModule,
        NgSelectModule,
        NgbTooltipModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CwtOrderHistorySearchComponent: {
                    component: KnBrOrderHistorySearchComponent,
                },
            },
        } as CmsConfig),
        KnBrOrderHistorySearchComponent,
    ],
})
export class KnBrOrderHistorySearchModule {}
